import React from 'react'
import PropTypes from 'prop-types'
import {TickIcon} from 'rambler-ui'
import Popup from 'components/Popup'
import ProfileItem from 'components/ProfileItem'
import styles from './styles.css'
import socialStyles from '../Social/styles.css'

export default function DefaultChampionat({
  accounts,
  defaultAccount,
  closable,
  onResolve,
  ...props
}) {
  return (
    <Popup
      {...props}
      title="Выбор основного аккаунта"
      showClose={closable}
      closeOnEsc={closable}
      closeOnClickOutside={closable}>
      <p>
        По правилам Чемпионата у пользователя может быть только один аккаунт.
        Пожалуйста, выберите, каким аккаунтом вы планируете пользоваться.
      </p>
      {accounts.map(({accountId}) => (
        <ProfileItem
          className={styles.item}
          key={accountId}
          leftIcon={<div className={socialStyles.champ} />}>
          <div>
            {accountId}
            &nbsp;&nbsp;
            {accountId === defaultAccount && (
              <TickIcon size={10} color="#28bc00" />
            )}
          </div>
          {accountId === defaultAccount ? (
            <small>Основной</small>
          ) : (
            <button
              type="button"
              data-anchor
              tabIndex="0"
              onClick={() => onResolve(accountId)}>
              Сделать основным
            </button>
          )}
        </ProfileItem>
      ))}
    </Popup>
  )
}

DefaultChampionat.propTypes = {
  accounts: PropTypes.array,
  defaultAccount: PropTypes.string,
  closable: PropTypes.bool,
  onResolve: PropTypes.func
}
